let url = new URL(window.location.href);
let search = url.search;

// query-string-entries to search for
let keys = ['knocking_aff', 'utm_source', 'utm_medium', 'utm_campaign', 'knocking_cmp'];

// prop-names for query-string items. defaults to their own name
let renaming = {
  'knocking_aff': 'affiliate',
  'knocking_cmp': 'campaign'
}

window.referalRenaming = {
  ...window.referalRenaming,
  ...renaming
}

let queryStringFull = search.replace('?', '&');

var queryStringArr = queryStringFull.split('&');

for (let i = 0; i < keys.length; i++) {
  let key = keys[i];

  for (let j = 0; j < queryStringArr.length; j++) {
    let queryString = queryStringArr[j];
    
    if (queryString.includes(key) || queryString.includes('kn_')) {
      let queryString = String(queryStringArr[j]).split('=');
      let queryKey = queryString[0];
      let queryValue = queryString[1];

      if (queryValue) {
        sessionStorage.setItem('referals-' + queryKey, queryValue);
      }
    }
  }
}